export enum SystemMode {
  ONLINE_TRAINING = 'onlineTraining',
  PILOT_ASSESSMENT = 'pilotAssessment',
}

export const PILOT_ASSESSMENT_ROOT = '/pilot-assesment'

export const resolveSystemMode = (path: string): SystemMode =>
  path.startsWith(PILOT_ASSESSMENT_ROOT)
    ? SystemMode.PILOT_ASSESSMENT
    : SystemMode.ONLINE_TRAINING

export const getSystemHomePath = (systemMode: SystemMode): string =>
  systemMode === SystemMode.PILOT_ASSESSMENT
    ? PILOT_ASSESSMENT_ROOT
    : '/'
